import AccessGate from '../../../pages/access_gate/AccessGate';
import MainLayout from './MainLayout';

const ProtectedLayout = ({ children }) => {

    return (

        <AccessGate>
            <MainLayout>
                {children}
            </MainLayout>
        </AccessGate>

    )

}

export default ProtectedLayout